import { combineReducers } from "redux";
import updateCampaignStatusReducer from "./updateCampaignStatusReducer";


const campaignReducer = combineReducers({
    updateCampaignStatus: updateCampaignStatusReducer,
});

export default campaignReducer;